/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModuleConfig } from '@schamburg-web/interfaces';
import { ImageMarker } from '@schamburg-web/lakecounty';
import {
  getLocationDescription,
  getNormalizedIcon,
  getRoadworkIcon,
} from '../utils';

const RoadworkMarker: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon }) => {
  return (
    <ImageMarker
      {...getRoadworkIcon(icon)}
      showOutline={false}
      title={getLocationDescription(getNormalizedIcon(icon))}
    />
  );
};

export default RoadworkMarker;
